import get from "lodash/get";
import { ERROR_SOLICITUD, RECHAZADO } from "@/config/constants/step-constants";

const Facebook = {
  enable() {
    let script = document.createElement("script"); // NOSONAR
    script.type = "text/javascript";
    script.onload = function() {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", "AW-793298531");
    };
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-793298531";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.gtag;
  },
  init() {
    window.fbq("init", "1649877658563488");
  },
  consulta() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/i5RYCM7ljqAYEOOMo_oC",
      transaction_id: ""
    });
  },
  ofertaCuenta() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/2PaxCOaMj6AYEOOMo_oC",
      transaction_id: ""
    });
  },
  mensaje(args) {
    const mensaje = get(args, "mutation.payload.params.mje", null);
    switch (mensaje) {
      case RECHAZADO:
      case ERROR_SOLICITUD:
        window.gtag("event", "conversion", {
          send_to: "AW-793298531/VGmjCIb4maAYEOOMo_oC",
          transaction_id: ""
        });
        break;
      default:
        break;
    }
  }
};

export default Facebook;
